import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { removeCompanyNote } from "../api/removeCompanyNote";

export const useRemoveCompanyNote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ companyId, noteId }) => removeCompanyNote({ companyId, noteId }),
    onSuccess: (_, variables) => {
      toast.success("Note removed successfully!");
      queryClient.invalidateQueries({ queryKey: ["companyNotes", variables.companyId] });
    },
    onError: (error) => {
      toast.error(error.message || "Failed to remove note.");
    },
  });
};

